import React from "react";
import "../styles/loading.css";

export default function Loading({ loading, error, children }) {

  if (error && !loading) {
    return (
      <div className="error-container">
        <img src="/error-icon-25240.png" alt="error" />
        <p>{error.message}</p>
      </div>
    );
  }

  if (children && !loading ) {
    return children;
  }

  return (
    <img
      className="loading-container"
      src="/Infinity-1s-200px.svg"
      alt="Loading"
    />
  );
}
